import { twMerge } from 'tailwind-merge';
import { CloseIcon } from '@/icons';
import { classes } from './utils';

export interface SearchFieldProps {
  className?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

export default function SearchField({
  className,
  placeholder = 'Search...',
  value,
  onChange,
}: SearchFieldProps) {
  return (
    <label className={twMerge(classes.field, className)}>
      <input
        className={classes.input}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <button
        aria-hidden={!value}
        className={twMerge(classes.clear, !value && classes.clearHidden)}
        tabIndex={value ? 0 : -1}
        type="button"
        onClick={() => onChange('')}>
        <CloseIcon fontSize="small" />
      </button>
    </label>
  );
}
